import { Directive, ElementRef, HostListener, OnInit, Renderer2, inject } from '@angular/core'

/**
 * For an anchor element to be truly accessible as a link, it must include a `href` attribute.
 * Without it, the element cannot be properly focused by keyboard navigation (e.g., Tab key)
 * and will not be recognized as a link by assistive technologies like screen readers.
 *
 * This directive makes an anchor element focusable without unnecessary navigation.
 * Adding 'href' also makes it responsive to keydown events in the browser.
 */
@Directive({
  selector: 'a[ftrFocusableNoopAnchor]',
})
export class FocusableNoopAnchorDirective implements OnInit {
  private element = inject<ElementRef>(ElementRef)
  private renderer = inject(Renderer2)

  ngOnInit(): void {
    const el = this.element.nativeElement as HTMLAnchorElement

    if (!el.hasAttribute('href')) {
      this.renderer.setAttribute(el, 'href', '')
    }
  }

  // The original click handler in component will still run after this
  @HostListener('click', ['$event'])
  handleClick(event: MouseEvent): void {
    event.preventDefault()
  }
}
